var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChat = function SvgIconChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.282 18.352v3.734l5.865-3.734h6.747c1.5 0 2.719-1.397 2.719-3.093v-7.51c0-1.708-1.228-3.094-2.72-3.094H5.72C4.219 4.655 3 6.052 3 7.748v7.51c0 1.707 1.228 3.094 2.719 3.094h.563Z",
    stroke: "#0000B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.623 8.389h2.755c1.5 0 2.718 1.397 2.718 3.093v7.51c0 1.707-1.227 3.094-2.718 3.094h-.564v3.734l-5.865-3.734h-6.746c-1.028 0-1.919-.652-2.383-1.614",
    stroke: "#0000B4"
  })));
};
export default SvgIconChat;